import { useDailyStats } from '@src/hooks/useQuests';
import { HStack, Skeleton, Text, VStack } from 'ui_2';
import parc_img from '@assets/parc.png';
import part_img from '@assets/part.png';

export const DailyStatsData = () => {
  const { data, isLoading, fetchStatus } = useDailyStats();
  const isActuallyLoading = isLoading && fetchStatus !== 'idle';

  return (
    <HStack className='w-full justify-between'>
      <VStack className='text-center'>
        {isActuallyLoading ? (
          <Skeleton className='h-6 w-6 self-center' />
        ) : (
          <HStack className='items-center justify-center gap-1'>
            <Text font='medium-lg'>{data?.parcEarned ?? 0}</Text>
            <img src={parc_img} className='h-5 w-5' />
          </HStack>
        )}
        <VStack className='-space-y-1'>
          <Text font='xxs'>PARC</Text>
          <Text font='xxs'>earned</Text>
        </VStack>
      </VStack>

      <VStack className='text-center'>
        {isActuallyLoading ? (
          <Skeleton className='h-6 w-6 self-center' />
        ) : (
          <HStack className='items-center justify-center gap-1'>
            <Text font='medium-lg'>{data?.partEarned ?? 0}</Text>
            <img src={part_img} className='-mt-1 h-5 w-5' />
          </HStack>
        )}
        <VStack className='-space-y-1'>
          <Text font='xxs'>PART</Text>
          <Text font='xxs'>earned</Text>
        </VStack>
      </VStack>

      <VStack className='text-center'>
        {isActuallyLoading ? (
          <Skeleton className='h-6 w-6 self-center' />
        ) : (
          <Text font='medium-lg'>{data?.giveawaysEntered ?? 0}</Text>
        )}
        <VStack className='-space-y-1'>
          <Text font='xxs'>Giveaways</Text>
          <Text font='xxs'>entered</Text>
        </VStack>
      </VStack>

      <VStack className='text-center'>
        {isActuallyLoading ? (
          <Skeleton className='h-6 w-6 self-center' />
        ) : (
          <Text font='medium-lg'>{data?.gamesPlayed ?? 0}</Text>
        )}
        <VStack className='-space-y-1'>
          <Text font='xxs'>Games</Text>
          <Text font='xxs'>played</Text>
        </VStack>
      </VStack>
    </HStack>
  );
};
